import * as actions from '../../store/actions/index';


// z.B. für calculator
export const locationTypeBySelectedSteps = (selectedSteps) => {
  if (selectedSteps && selectedSteps.location) {

    if (['wl', 'wl75', 'wm', 'wm150', 'hw1', 'hw2', 'sl', 'sl80', 'sl95', 'sm'].includes(selectedSteps.location)) {
      return "wand"
    } else if ( ['d', 'd200', 'hd120', 'hd150'].includes(selectedSteps.location)) {
      return "decke"
    } else return undefined
  } else {
    return undefined
  }
}

export const locationType = (selectedSteps) => {
  if (selectedSteps && selectedSteps.location) {
    if (['wl', 'wl75', 'wm', 'wm150', 'hw1', 'hw2', 'sl', 'sl80', 'sl95', 'sm'].includes(selectedSteps.location)) {
      return "wand"
    } else if ( ['d', 'd200', 'hd120', 'hd150'].includes(selectedSteps.location)) {
      return "decke"
    } else return undefined
  } else {
    return undefined
  }
}


export const productSystemCalcSettings = (productSystem) => ({
  calculator_wand_max_breite: parseFloat(productSystem.calculator_wand_max_breite) || 0,
  calculator_wand_max_hoehe: parseFloat(productSystem.calculator_wand_max_hoehe) || 0,
  calculator_decke_max_breite: parseFloat(productSystem.calculator_decke_max_breite) || 0,
  calculator_decke_max_hoehe: parseFloat(productSystem.calculator_decke_max_hoehe) || 0,
  calculator_krit_bp: parseFloat(productSystem.calculator_krit_bp) || 0,
  calculator_leerschott_allowed: productSystem.calculator_leerschott_allowed,
  calculator_max_bp: parseFloat(productSystem.calculator_max_bp) || 0,
  calculator_status: productSystem.calculator_status,
})

export const calculateSchottbelegung = ( t, items, calculatorData, location, calcSettings, productSystemsItems ) => {
  let status = 'not_available';
  let errors = [];
  let sum_in_percent = 0;
  let hole_width_int = parseFloat(calculatorData.hole_width) || 0;
  let hole_height_int = parseFloat(calculatorData.hole_height) || 0;
  let hole_diameter_int = parseFloat(calculatorData.hole_diameter) || 0;
  let calculator_short_side = 0;
  let calculator_long_side  = 0;
  let hole_short_side = Math.min(hole_width_int, hole_height_int);
  let hole_long_side = Math.max(hole_width_int, hole_height_int);
  let max_breite = 0;
  let max_hoehe = 0;

  const pi = 3.14159265359;

  const calcSchottsize = (pi, hole_form, hole_width, hole_height, hole_diameter) => {
    let schottsize = 0;
    if (hole_form === 'square') {
      schottsize = hole_width * hole_height;
    } else if (hole_form === 'circle') {
      schottsize = parseInt(pi * Math.pow((parseFloat(hole_diameter)/2), 2),10);
    }
    return schottsize;
  }

  let schottsize = calcSchottsize(pi, calculatorData.hole_form, hole_width_int, hole_height_int, hole_diameter_int);
  let max_area_allocation_in_area = parseInt(schottsize * parseFloat(calcSettings.calculator_max_bp)/100, 10) || 0;
  let krit_area_allocation_in_area = parseInt(schottsize * parseFloat(calcSettings.calculator_krit_bp)/100, 10) || 0;
  let sum_area_penetrations = 0;

  const global_max_diameter_isolierung = 80;

  if (location === "decke") {
    max_breite = calcSettings.calculator_decke_max_breite;
    max_hoehe = calcSettings.calculator_decke_max_hoehe;
  }

  if (location === "wand") {
    max_breite = calcSettings.calculator_wand_max_breite;
    max_hoehe = calcSettings.calculator_wand_max_hoehe;
  }

  calculator_short_side = Math.min(max_breite, max_hoehe);
  calculator_long_side  = Math.max(max_breite, max_hoehe);

  if (calculatorData.hole_form === 'square') {
    if (calculator_short_side < hole_short_side || calculator_long_side < hole_long_side) {
      errors.push(t('product_solution.calculation_result.width_or_hight_to_large', {max_breite: max_breite, max_hoehe: max_hoehe}))
    }
  } else if (calculatorData.hole_form === 'circle') {
    if (calculator_short_side < hole_diameter_int) {
      errors.push(t('product_solution.calculation_result.hole_diameter_to_big', {maximum: calculator_short_side}))
    }
  }


  for (let item of productSystemsItems) {
    let additional_area = 0


    let itemWithAmount = items.filter(obj => {
      return obj.id === item.id
    })

    // Rohre
    if (actions.availableMediumTypesTubes.includes(item.medium_type)) {
      let insulation_min = parseFloat(item.insulation_strength_min) || 0;

      if ( insulation_min === 0 ) {
        additional_area = pi * Math.pow((parseFloat(item.diameter_max)/2), 2)

      } else if (insulation_min > 0 && ["CI", "LI"].includes(item.insulation_configuration) ) {
        additional_area = pi * Math.pow((parseFloat(item.diameter_max)/2), 2)

      } else if (insulation_min > 0 && ["CS", "LS"].includes(item.insulation_configuration) ) {
        let iso = parseFloat(item.insulation_strength_max);
        if (iso > global_max_diameter_isolierung) {
          iso = global_max_diameter_isolierung
        }
        additional_area =  pi * Math.pow(((parseFloat(item.diameter_max)/2) + iso), 2)
      }

    // Kabel
    } else if (actions.availableMediumTypesCables.includes(item.medium_type)) {

      let max_diameter_buendel = parseFloat(item.max_diameter_buendel) || 0 ;
      let max_diameter_einzelleitung = parseFloat(item.max_diameter_einzelleitung) || 0;
      let max_diameter_eirx_diameter_buendel = parseFloat(item.max_diameter_eir) || 0;
      let max_diameter = Math.max(max_diameter_buendel, max_diameter_einzelleitung, max_diameter_eirx_diameter_buendel);

      additional_area = pi * Math.pow((parseFloat(max_diameter)/2), 2)
    }

    sum_area_penetrations = sum_area_penetrations + itemWithAmount[0].amount * additional_area

  }

  if (sum_area_penetrations < krit_area_allocation_in_area ) {
    status = "lower_than_krit"  // green
  } else if ((max_area_allocation_in_area > sum_area_penetrations) && (sum_area_penetrations > krit_area_allocation_in_area) ) {
    status = "between_max_and_krit" // orange
  } else if (sum_area_penetrations > max_area_allocation_in_area ) {
      status = "greater_than_max" // red
    }

  sum_area_penetrations = parseInt(sum_area_penetrations, 10);

  // Manchmal, bei einer sehr kleinen Abdeckung, wird 0 angezeigt. Wir haben uns entschieden in diesem
  // Fall als Untergrenze immer die Ziffer 1 anzuzeigen.

  if (productSystemsItems.length > 0 ) {
    sum_in_percent = Math.max(parseInt((sum_area_penetrations/schottsize) * 100, 10), 1);
  } else {
    sum_in_percent = 0;
  }

  const reserve_in_area = max_area_allocation_in_area - sum_area_penetrations;
  const reserve_in_percent = calcSettings.calculator_max_bp - sum_in_percent;

  // leerschott prüfung

  if (calcSettings.calculator_leerschott_allowed === false && productSystemsItems.length === 0) {
    errors.push(t('product_solution.calculation_result.leerschott_not_allowed'))
  }


  const calculationSchottbelegungSuccess = (errors.length === 0 && ['square', 'circle'].includes(calculatorData.hole_form) && calcSettings.calculator_status === true);

  const result = (['square', 'circle'].includes(calculatorData.hole_form))?

   {
    calculationSchottbelegungSuccess: calculationSchottbelegungSuccess,
    sum_in_area: sum_area_penetrations,
    sum_in_percent: sum_in_percent,
    reserve_in_area: reserve_in_area,
    reserve_in_percent: reserve_in_percent,
    possible_area: schottsize,
    krit_area_allocation_in_area: krit_area_allocation_in_area,
    max_area_allocation_in_area: max_area_allocation_in_area,
    krit_area_allocation_in_percent: calcSettings.calculator_krit_bp,
    max_area_allocation_in_percent: calcSettings.calculator_max_bp,
    errors: errors,
    status: status
  } :

  {
   calculationSchottbelegungSuccess: false,
   sum_in_area: 0,
   sum_in_percent: 0,
   reserve_in_area: 0,
   reserve_in_percent: 0,
   possible_area: 0,
   krit_area_allocation_in_area: 0,
   max_area_allocation_in_area: 0,
   krit_area_allocation_in_percent: 0,
   max_area_allocation_in_percent: 0,
   errors: errors,
   status: 'not_available'
 }


  return result;
}



// WEBPACK FOOTER //
// ./src/store/actions/calculator.js